import { z } from "zod";

export const labelPinAdminStatusSchema = z.object({
  configured: z.boolean(), version: z.number().int().positive().nullable(), pending: z.boolean(),
  delivery: z.enum(["queued", "accepted", "delivery_unknown", "blocked"]).nullable(),
});
export type LabelPinAdminStatus = z.infer<typeof labelPinAdminStatusSchema>;
export const labelPinQueuedSchema = z.object({ queued: z.literal(true), version: z.number().int().nonnegative(), delivery: z.literal("queued") });
export const labelPinAssignmentSchema = z.object({
  configured: z.literal(true),
  version: z.number().int().positive(),
  delivery: z.enum(["not_requested", "queued"]),
});
